import type { Patient } from "@medplum/fhirtypes";
import { PATIENT_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Patient resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const usePatientSubscription = createSubscriptionHook<Patient>("Patient", PATIENT_COLLECTION_NAME);
